var _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon icon-tabler icon-tabler-layout-sidebar-left-expand",
    fill: "none",
    height: 24,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none",
    stroke: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 16,
    rx: 2,
    width: 16,
    x: 4,
    y: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4v16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10l2 2l-2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarOpen);
export default __webpack_public_path__ + "static/media/sidebar-open.6ca15a0f893bbd446287c13037b7fa9f.svg";
export { ForwardRef as ReactComponent };